import qs from 'qs'

import { HttpService, HttpServiceResponse } from '../shared'
import {
  GetRatesAttributes,
  RatesAddActions,
  AddNBGRateAttributes,
  AddCommercialRateAttributes,
  DeleteNBGRateAttributes,
} from './rates.types'

export class RatesProvider {
  constructor(private http: HttpService, private baseUrl: string) {}

  private get url(): string {
    return this.baseUrl
  }

  public get<T>(attributes: GetRatesAttributes): Promise<HttpServiceResponse<T>> {
    const queryString = qs.stringify(attributes)

    return this.http.post(`${this.url}/rate_view_api.php?${queryString}`)
  }

  public addNBGRate(attributes: AddNBGRateAttributes): Promise<HttpServiceResponse<void>> {
    const queryString = qs.stringify({
      action: RatesAddActions.Add,
      ...attributes,
    })

    return this.http.post(`${this.url}/rate_nbg_add_api.php?${queryString}`)
  }

  public deleteNBGRate(attributes: DeleteNBGRateAttributes): Promise<HttpServiceResponse<void>> {
    const queryString = qs.stringify({
      action: RatesAddActions.Delete,
      ...attributes,
    })

    return this.http.post(`${this.url}/rate_nbg_add_api.php?${queryString}`)
  }

  public addCommercialRate(attributes: AddCommercialRateAttributes): Promise<HttpServiceResponse<void>> {
    const queryString = qs.stringify({
      action: RatesAddActions.Add,
      ...attributes,
    })

    return this.http.post(`${this.url}/rate_comm_add_api.php?${queryString}`)
  }

  public deleteCommercialRate(attributes: Object): Promise<HttpServiceResponse<void>> {
    const queryString = qs.stringify({
      action: RatesAddActions.Delete,
      ...attributes,
    })

    return this.http.post(`${this.url}/rate_comm_add_api.php?${queryString}`)
  }
}
